module.exports = __webpack_public_path__ + "img/primary.ebfbbee2.svg";